module.exports = __webpack_public_path__ + "media/images/icons/filled/right-square-58133ee50230b37d652e75a1871be78e.svg";